const TransformSection = () => {
  const stats = [
    {
      number: "98",
      symbol: "%",
      label: "Clean Claim",
      icon: (
        <svg className="w-16 h-16" viewBox="0 0 64 64" fill="none" stroke="currentColor" strokeWidth="3">
          <circle cx="32" cy="32" r="24" />
          <path d="M20 32 L28 40 L44 24" strokeLinecap="round" strokeLinejoin="round" />
          <circle cx="32" cy="32" r="18" strokeDasharray="4 4" opacity="0.5" />
        </svg>
      )
    },
    {
      number: "30",
      symbol: "%",
      label: "Revenue Boost",
      icon: (
        <svg className="w-16 h-16" viewBox="0 0 64 64" fill="none" stroke="currentColor" strokeWidth="3">
          <circle cx="32" cy="32" r="20" />
          <path d="M32 20 L32 44 M24 28 L32 20 L40 28" strokeLinecap="round" strokeLinejoin="round" />
          <path d="M20 36 L26 30 L32 34 L38 28 L44 32" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      )
    },
    {
      number: "96",
      symbol: "%",
      label: "Collection Ratio",
      icon: (
        <svg className="w-16 h-16" viewBox="0 0 64 64" fill="none" stroke="currentColor" strokeWidth="3">
          <circle cx="32" cy="32" r="20" />
          <path d="M32 20 L32 32 L44 32" strokeLinecap="round" strokeLinejoin="round" />
          <path d="M24 24 L32 32 L40 24" strokeLinecap="round" strokeLinejoin="round" opacity="0.5" />
        </svg>
      )
    },
    {
      number: "99",
      symbol: "%",
      label: "First Pass Ratio",
      icon: (
        <svg className="w-16 h-16" viewBox="0 0 64 64" fill="none" stroke="currentColor" strokeWidth="3">
          <circle cx="32" cy="32" r="20" />
          <path d="M22 32 L30 40 L46 24" strokeLinecap="round" strokeLinejoin="round" />
          <circle cx="32" cy="32" r="14" opacity="0.3" />
        </svg>
      )
    }
  ];

  return (
    <section className="bg-gradient-to-br from-blue-50 to-white py-10">
      <div className="max-w-[1330px] mx-auto px-4 sm:px-6 lg:px-8">
        
        {/* Section Heading */}
        <div className="text-center mb-12">
          <h2 className="text-4xl lg:text-5xl font-bold mb-4">
            <span className="text-blue-500">Transform Your Practice</span>{' '}
            <span className="text-gray-900">with Expert Physician Billing Services</span>
          </h2>
          <p className="text-gray-600 text-base lg:text-lg max-w-4xl mx-auto leading-relaxed">
            Our team of professionals takes care of your billing immediately and effectively so you have time to focus on delivering 
            patient care and growing your practice.
          </p>
        </div>

        {/* Stats Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {stats.map((stat, index) => (
            <div 
              key={index}
              className="bg-gradient-to-br from-blue-800 to-blue-600 rounded-2xl p-8 text-white relative overflow-hidden group hover:scale-105 transition-transform duration-300"
            >
              {/* Decorative background pattern */}
              <div className="absolute inset-0 opacity-10">
                <div className="absolute top-0 right-0 w-32 h-32 border-4 border-white rounded-full -mr-16 -mt-16"></div>
                <div className="absolute bottom-0 left-0 w-24 h-24 border-4 border-white rounded-full -ml-12 -mb-12"></div>
              </div>

              <div className="relative z-10">
                {/* Icon */}
                <div className="flex justify-center mb-6">
                  <div className="text-white opacity-90 group-hover:opacity-100 transition-opacity">
                    {stat.icon}
                  </div>
                </div>

                {/* Divider with plus */}
                <div className="flex items-center justify-center mb-6">
                  <div className="flex-1 h-px bg-white opacity-30"></div>
                  <div className="mx-4 text-2xl font-bold opacity-50">+</div>
                  <div className="flex-1 h-px bg-white opacity-30"></div>
                </div>

                {/* Number and Label */}
                <div className="text-center">
                  <div className="flex items-start justify-center mb-2">
                    <span className="text-6xl font-bold">{stat.number}</span>
                    <span className="text-3xl font-bold ml-1 mt-2">{stat.symbol}</span>
                  </div>
                  <p className="text-lg font-semibold opacity-90">{stat.label}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
};

export default TransformSection;
